module.exports = __webpack_public_path__ + "static/media/image3.5d0ff480.jpeg";